import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Root from '../components/Root';
import '../i18n';
import '../utils/sentry';
import '../styles/application.css';
ReactDOM.render(React.createElement(Root, null), document.getElementById('content'));
